import {useDocumentContext} from '@/components/document/context';
import Label from '@/components/form/label';
import SubSectionTitle from '@/components/sub-section-title';
import {DocumentUIField} from '@/engine/types';
import {FieldProps} from '../../meta-field';

export const SubsectionTitleField = ({field}: FieldProps<DocumentUIField>) => {
  const {valueResolver, visibilitySet} = useDocumentContext();

  const label = valueResolver(field.label, {visibilitySet});

  if (field.layout?.size === 'small') {
    return (
      <div className="-mb-4">
        <Label multiline>{label}</Label>
      </div>
    );
  }

  return <SubSectionTitle>{label}</SubSectionTitle>;
};
